export default __webpack_public_path__ + "static/media/head03_vi_pc@2x.f53ca374.png";